<template>
    <div class="dialog">
        <el-dialog :title="this.edit_id == 0 ? '创建接龙活动' : '编辑接龙活动'" :visible.sync="dialogVisible" width="996px" :before-close="handleClose">
            <div class="content">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" label-position="left" class="demo-ruleForm">
                    <h3 class="sub-title">基础设置</h3>
                    <el-form-item label="活动名称：" prop="name">
                        <el-input v-model="ruleForm.name" :disabled="isDetail" clearable placeholder="请输入活动名称，不超过20个字"></el-input>
                    </el-form-item>
                    <el-form-item label="活动时间：" prop="date">
                        <el-date-picker
                            v-model="ruleForm.date"
                            style="width: 100%"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="expireTimeOption"
                            :disabled="isDetail"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="活动说明：" prop="explain" class="none">
                        <el-input v-model="ruleForm.explain" :disabled="isDetail" type="textarea" 
                         maxlength="500"
  show-word-limit
                        :rows="4" clearable placeholder="可对活动的其他信息作说明，如：发货情况等。"></el-input>
                    </el-form-item>
                    <el-form-item label="活动有效期：" prop="task_time">
                        <div>
                            <el-input-number v-model="ruleForm.dd" :disabled="isDetail" clearable style="width: 120px" :min="0" :max="30"> </el-input-number> 日
                            <span v-show="ruleForm.dd != 30">
                                <el-input-number v-model="ruleForm.hh" :disabled="isDetail" clearable :min="0" :max="23" style="width: 120px; margin-left: 16px"> </el-input-number> 时</span
                            >
                            <span v-show="ruleForm.dd != 30">
                                <el-input-number v-model="ruleForm.mm" :disabled="isDetail" clearable :min="0" :max="59" style="width: 120px; margin-left: 16px"> </el-input-number> 分</span
                            >
                        </div>
                        <p class="tip-text">拼团有效期需在15分钟至30天之间 若设置1日，用户开团后，需要在1日内成团，超时则失败</p>
                    </el-form-item>
                    <el-form-item label="是否限制购买次数：" prop="purchases_type" class="df">
                        <el-radio-group v-model="ruleForm.purchases_type" :disabled="isDetail">
                            <el-radio label="0">不限制</el-radio>
                            <el-radio label="1">限制每人最多次数</el-radio>
                            <el-input v-model="ruleForm.buyLimit" v-show="ruleForm.purchases_type == 1" oninput="value=value.replace(/[^\d]/g,'')" style="width: 180px">
                                <template slot="append">次</template></el-input
                            >
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="发起接龙返现：" prop="type">
                        <el-radio-group v-model="ruleForm.type" :disabled="isDetail">
                            <el-radio label="1">返还现金</el-radio>
                        </el-radio-group>
                        <p class="tip">发起接龙的用户下单后邀请朋友下单，将获得发起人返现奖励</p>
                    </el-form-item>
                    <el-form-item label="返现设置 ：" class="df">
                        <el-input
                            v-model="ruleForm.reward_share"
                            style="width: 180px"
                           :disabled="Number(ruleForm.reward_share) == '' && Number(ruleForm.reward_cash) != ''"
                            oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                        >
                            <template slot="append">%</template>
                        </el-input>
                        <span style="margin: 0 12px">或</span>
                        <el-input
                            v-model="ruleForm.reward_cash"
                            style="width: 180px"
                            :disabled="Number(ruleForm.reward_cash) == '' && Number(ruleForm.reward_share) != ''"
                            oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                        >
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="返现条件：">
                        <p>自己的接龙成员订单支付完成 7 天内，未申请退款</p>
                    </el-form-item>

                    <el-form-item label="优惠叠加：" prop="coupon_type">
                        <el-radio-group v-model="ruleForm.coupon_type" :disabled="isDetail">
                            <el-radio label="1">不叠加其他营销活动或优惠券</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" 
                 v-if="!isDetail"
                 @click="submit">保 存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";

export default {
    data() {
        return {
            expireTimeOption: {
                disabledDate(date) {
                    //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
                    return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
                },
            },
            dialogVisible: false,
            ruleForm: {
                name: "",
                date: null,
                explain: "",
                purchases_type: "1",
                dd: "",
                hh: "",
                mm: "",
                buyLimit: "",
                type: "1",
                reward_share: "",
                reward_cash: "",
                coupon_type: "1",
            },
            rules: {
                name: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
                date: [{ required: true, message: "请选择活动时间", trigger: "change" }],
                rule_type: [{ required: true, message: "请输入返现规则", trigger: "change" }],
            },
        };
    },
    props: {
        count: {
            type: Number,
            default: 0,
        },
        activityProductData: {
            type: Array,
            default: () => {
                return [];
            },
        },
        edit_id: {
            type: Number,
            default: 0,
        },
        noProductEdit: {
            type: Number,
            default: 0,
        },
        isDetail: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    methods: {
        ...mapActions({
            createActivityLink: "activity/createActivityLink",
            editLink: "activity/editLink",
            getActivityDetailLinknk: "activity/getActivityDetailLink",
        }),
        getDetail(id) {
            this.loading = true;
            let params = {
                token: this.getToken,
                id: id,
            };
            this.getActivityDetailLinknk(params).then(({ data }) => {
                if (data.code == 1) {
                    let { name, start_time, end_time, reward_cash, reward_share, explain, task_time, buy_limit } = data.data;
                    let purchases_type = buy_limit == 0 ? "0" : "1";
                    let dd, hh, mm;
                    dd = parseInt(task_time / 24 / 60 / 60);
                    hh = parseInt((task_time - dd * 24 * 60 * 60) / 60 / 60);
                     mm = task_time<=3540?parseInt(task_time/60):parseInt((task_time - dd * 24 * 60 * 60 - hh * 60 * 60)/60);
                    this.ruleForm = {
                        name: name,
                        dd: dd,
                        hh: hh,
                        mm: mm,
                        date: [start_time, end_time],
                        reward_share: Number(reward_share) == 0 ? "" : Number(reward_share),
                        reward_cash: Number(reward_cash) == 0 ? "" : Number(reward_cash),
                        explain: explain,
                        buyLimit: Number(buy_limit) == 0 ? "" : Number(buy_limit),
                        coupon_type: "1",
                        type: "1",
                        purchases_type: purchases_type,
                    };
                } else {
                    this.$message.error(data.msg);
                }
                this.loading = false;
            });
        },
        submit() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    // if (this.activityProductData.length == 0) {
                    //     return this.$message.warning("请选择商品！");
                    // }
                    let { name, explain, date, dd, hh, mm, reward_share, reward_cash, purchases_type, buyLimit } = this.ruleForm;

                    if (dd == 30) {
                        hh = 0;
                        mm = 0;
                    }
                    if ((purchases_type == 2 && buyLimit == "") || (purchases_type == 2 && buyLimit == 0)) {
                        return this.$message.warning("请输入购买次数！");
                    }
                    let params = {
                        token: this.getToken,
                        name: name,
                        type: "1",
                        explain: explain,
                        start_time: date ? date[0] : null,
                        end_time: date ? date[1] : null,
                        task_time: dd * 24 * 60 * 60 + hh * 60 * 60 + mm * 60,
                        reward_share: reward_share,
                        reward_cash: reward_cash,
                     /*    activityProductData: [],
                        noProductEdit: 0, */
                    };
                    if (purchases_type == 1) {
                        params.buy_limit = buyLimit;
                    } else {
                        params.buyLimit = 0;
                    }
                    let url;
                    if (this.edit_id == 0) {
                        url = this.createActivityLink;
                    } else {
                        url = this.editLink;
                        params.id = this.edit_id;
                    }
                    url(params).then(({ data }) => {
                        if (data.code == 1) {
                            this.$message.success(`${this.edit_id == 0 ? "添加成功" : "修改成功"}！`);
                            this.handleClose();
                        } else {
                            this.$message.error(data.msg);
                        }
                        this.$emit("initList");
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        handleClose() {
            this.dialogVisible = false;
            this.$refs.ruleForm.resetFields();
            this.ruleForm = {
                name: "",
                date: null,
                dd: "",
                hh: "",
                mm: "",
                explain: "",
                purchases_type: "1",
                buyLimit: "",
                type: "1",
                reward_share: "",
                reward_cash: "",
                coupon_type: "1",
            };
            this.$emit("dataInit");
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #dcdfe6;
}
::v-deep .el-dialog__body {
    padding: 30px 40px;
    height: 550px;
    overflow-y: auto;
    &::-webkit-scrollbar-track-piece {
        background: #d3dce6;
    }

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-thumb {
        background: #99a9bf;
        border-radius: 20px;
    }
}
.df {
    ::v-deep .el-form-item__content {
        display: flex;
    }
}
.el-radio {
    height: 36px;
    line-height: 36px;
}
.el-radio-group {
    position: relative;
    width: 100%;
    .el-input {
        position: absolute;
        right: 100px;
        bottom: 0;
    }
    .tip {
        position: absolute;
        right: 160px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 14px;
        color: #999;
    }
}
.none {
    ::v-deep .el-form-item__label {
        &::before {
            content: "*";
            color: #f56c6c;
            margin-right: 4px;
            display: none;
        }
    }
}
::v-deep .el-form-item__label {
    &::before {
        content: "*";
        color: #f56c6c;
        margin-right: 4px;
    }
}
.df {
    .el-radio-group {
        display: flex;
        flex-direction: column;
    }
}
.sub-title {
    margin: 60px 0 40px;
    font-size: 18px;
    color: #333;
    margin-right: 10px;
    padding-left: 12px;
    position: relative;
    &:first-child {
        margin-top: 0;
    }
    &::before {
        content: "";
        width: 3px;
        height: 18px;
        background: #2448ff;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
    }
}

::v-deep .el-range-editor.is-disabled input,
::v-deep .el-input.is-disabled .el-input__inner,
::v-deep .el-radio__input.is-disabled + span.el-radio__label {
    color: #666;
}
</style>